import { Component, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { formItem } from '../preview-forms.interface';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Component({
    selector: 'app-form-date',
    templateUrl: './form-date.component.html',
    styleUrls: ['./form-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormDateComponent {
  date: any;
  form!: formItem;

  constructor(private elRef: ElementRef) {

  }

  @Input('model') set item(v: formItem) {
    this.form = v;
    if (this.form?.answer_value) this.setValue()
  }
  @Output('valid') valid = new EventEmitter()

  @Output('update') update = new EventEmitter()

  setValue() {
    this.date = moment(this.form.answer_value).format('DD/MM/YYYY')
  }
  updateValue() {
    this.update.emit(moment(this.date).format())
    if (moment(this.date).format()) this.valid.emit(false)
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
